// src/components/layout/Topbar.tsx
import { GlowLogo } from '@/components/ui/GlowLogo';

// bookingId prop removed 28 Sep 2026 — it was declared and passed in from
// DashboardPage but never actually used anywhere in this component's
// render output (no booking-specific title/breadcrumb was ever built here).
// Re-add a prop here (and its passthrough in DashboardPage) if/when this
// component actually needs to show something booking-specific.
export function Topbar() {
  return (
    <nav
      style={{
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        borderBottom: '1px solid rgba(var(--fg-rgb),0.05)',
        background: 'var(--input-recessed-bg)',
        flexShrink: 0,
      }}
    >
      <div className="topbar-title">
        <GlowLogo label="Control Centre" size="sm" />
      </div>

    </nav>
  );
}
